export function applyAuthorizationHeader(headers: Headers, authHeader: string | null): void {
  if (headers.has("Authorization")) {
    return;
  }

  if (!authHeader) {
    return;
  }

  headers.set("Authorization", authHeader);
}
